/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {useEffect, useRef, useState} from "react";
import type { QrcodeSuccessCallback, QrcodeErrorCallback} from 'html5-qrcode';
import {Html5QrcodeScanner, Html5QrcodeScanType, Html5QrcodeSupportedFormats} from 'html5-qrcode';
import type {Html5QrcodeScannerConfig} from "html5-qrcode/html5-qrcode-scanner.js";

export const qrCodeReaderConfig = {
    fps: 60,
    disableFlip: false,
    useBarCodeDetectorIfSupported: true,
    videoConstraints: {
        facingMode: "environment",
        width: 3000,
        height: 3000,
        aspectRatio: 1
    },
    formatsToSupport: [Html5QrcodeSupportedFormats.QR_CODE, Html5QrcodeSupportedFormats.CODE_128],
    supportedScanTypes: [Html5QrcodeScanType.SCAN_TYPE_CAMERA]
};

const videoConstraints: MediaTrackConstraints = {
    facingMode: { ideal: "environment" },
    width: { min: 1024, ideal: 4096, max: 4096 },
    height: { min: 540, ideal: 2160, max: 2160 },
    frameRate: { ideal: 60, max: 60 }
}

// the best solution I found for android & iphone
export const qrCodeReaderConfigForMobile: Html5QrcodeScannerConfig = {
    fps: 10,
    qrbox: 250,
    useBarCodeDetectorIfSupported: true,
    rememberLastUsedCamera: true,
    aspectRatio: 1,
    showZoomSliderIfSupported: true,
    defaultZoomValueIfSupported: 2,
    formatsToSupport: [Html5QrcodeSupportedFormats.QR_CODE, Html5QrcodeSupportedFormats.CODE_128],
    supportedScanTypes: [Html5QrcodeScanType.SCAN_TYPE_CAMERA],
    videoConstraints: videoConstraints
};

const qrcodeRegionId = "html5qr-code-full-region";


const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return isMobile;
};



export const Html5QrcodePluginFallback = (props: { qrCodeSuccessCallback: QrcodeSuccessCallback, qrCodeErrorCallback?: QrcodeErrorCallback }) => {
    const ref = useRef<Html5QrcodeScanner | null>(null);

    let qrReaderConfig: Html5QrcodeScannerConfig = qrCodeReaderConfigForMobile;
    // Usage
    const isMobile = useIsMobile();
    if (!isMobile)
        qrReaderConfig = qrCodeReaderConfig;

    useEffect(() => {
        // if (rendered)
        //     return;

        console.log("Html5QrcodePluginFallback")
        if (ref.current === null) {
            ref.current = new Html5QrcodeScanner(qrcodeRegionId, qrReaderConfig, false);
            ref.current.render(props.qrCodeSuccessCallback, props.qrCodeErrorCallback);
        }

        // cleanup function when component will unmount
        return () => {
            ref.current?.clear().catch(console.error);

            navigator
                .mediaDevices
                .getUserMedia({video: true, audio: false})
                .then(stream => stream.getTracks().forEach(track => {
                    track.stop();
                }))
                .catch(console.error)
        };
    }, []);

    return (
        <div id={qrcodeRegionId} style={{width: '80vw'}}/>
    );
};
